import { Component, h, render } from "preact";
import {
  INJECT_WRAPPER_ELEMENT,
  PRODUCT_ELEMENT,
  PRODUCT_UID_ATTR,
} from "@/constants/selectors";

import $ from "jquery";
import Minilog from "minilog";
import ReviewForm from "@/components/ReviewForm/ReviewForm";
import ReviewsList from "@/components/ReviewsList/ReviewsList";
import Stars from "@/components/ProductRating/ProductRating";
import { injectRatingsInProuctCard } from "@/utils/injectRatingsInProductCards";
import { loadRatings } from "@/utils/loadRatings";
import { onElementsReady } from "@/utils/onElementsReady";

// eslint-disable-next-line new-cap
const logger = Minilog("778");
Minilog.enable();

export async function initBlock778() {
  logger.info("initBlock778 start");

  onElementsReady(
    `[data-record-type="778"] ${PRODUCT_ELEMENT}, .t778 ${PRODUCT_ELEMENT}`,
    (product) => {
      loadRatings($(product), logger);
      injectRatingsInProuctCard($(product), logger);
    }
  );

  onElementsReady(
    `[data-record-type="778"] .t-popup .js-store-product, .t778 .t-popup .js-store-product`,
    (element) => {
      const productUid = $(element).attr(PRODUCT_UID_ATTR);
      if (!productUid) return;

      const popupElement = $(element).parents(".t-popup");
      popupElement.find(".__CC-inject").remove();

      const popupContainer = popupElement.find(
        ".t-store__prod-popup__container"
      );

      const reviewsListElement = $(INJECT_WRAPPER_ELEMENT).addClass(
        "reviews-list"
      );
      render(
        <ReviewsList productUid={productUid} />,
        reviewsListElement.get(0)
      );
      popupContainer.append(reviewsListElement);

      const reviewFormElement = $(INJECT_WRAPPER_ELEMENT).addClass(
        "review-form"
      );
      render(<ReviewForm productUid={productUid} />, reviewFormElement.get(0));
      popupContainer.append(reviewFormElement);

      const popupProductName = popupElement.find(".t-store__prod-popup__name");
      const starsMiniElModalElement = $(INJECT_WRAPPER_ELEMENT).addClass(
        "stars-mini"
      );
      render(<Stars productUid={productUid} />, starsMiniElModalElement.get(0));
      popupProductName.before(starsMiniElModalElement);
    }
  );

  logger.info("initBlock778 finish");
}
